module.exports = __webpack_public_path__ + "media/assets/ccw_islands_screenshot-f3ac4677.png";